const planTypes = [
    'Original Medicare',
    'Dental',
    'Medigap',
    'Medicare Advantage',
    'Medicare Supplement',
    'Medicare Part A',
    'Medicare Part B',
    'Medicare Part C',
    'Medicare Part D',
    'Medicaid',
    'Vision',
];

const topics = [
    'Financial',
    'Enrollment',
    'Lifestyle',
    'Doctors',
    'AEP',
    'OEP',
    'SEP',
    'Coverage',
    'Private Insurance'
];

const allTags = [...planTypes, ...topics];

export { allTags, planTypes, topics };
